import React, { useRef, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Button } from '@siftscience/focus-components/button'
import { Plus } from '@siftscience/focus-components/icons'
import { Popover } from '@siftscience/focus-components/popover'
import { Title } from '@siftscience/focus-components/text'
import { TextInput } from '@siftscience/focus-components/input'
import { Select } from '@siftscience/focus-components/select'
import capitalize from 'lodash/capitalize'
import { useProcessorContext } from '../context/processor-context'

const PROCESSOR_FIELD_OPTIONS = ['string', 'image', 'pdf']

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    padding: '16px',
    borderTop: '1px solid #D9D9D9'
  },
  button: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px'
  },
  formWrapper: {
    width: '276px'
  },
  popover: {
    zIndex: 9999
  },
  formMainBody: {
    padding: '16px',
    borderBottom: '1px solid #E0E0E0'
  },
  formActions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: '56px',
    padding: '12px 16px'
  },
  formSelect: {
    width: '100%',

    '& button': {
      width: '100%'
    }
  },
  formBlock: {
    marginBottom: '8px'
  },
  formTitle: {
    marginBottom: '4px'
  },
  formInput: {
    width: '100%'
  }
}))

const AddProcessorField = () => {
  const { createProcessorField } = useProcessorContext()
  const [fieldName, setFieldName] = useState('')
  const [fieldType, setFieldType] = useState('')
  const popoverOnClickRef = useRef(null)
  const classes = useStyles()

  const cleanForm = () => {
    setFieldName('')
    setFieldType('')
  }

  const onCancel = event => {
    popoverOnClickRef.current(event)
    cleanForm()
  }
  const onAdd = event => {
    createProcessorField(fieldName, fieldType)
    cleanForm()
    popoverOnClickRef.current(event) // close popover
  }

  return (
    <div className={classes.wrapper}>
      <Popover
        placement="top"
        className={classes.popover}
        content={() => (
          <div className={classes.formWrapper}>
            <div className={classes.formMainBody}>
              <div className={classes.formBlock}>
                <Title
                  size="xsmall"
                  color="secondary"
                  className={classes.formTitle}
                >
                  Field Name
                </Title>
                <TextInput
                  value={fieldName}
                  onChange={event => setFieldName(event?.target?.value)}
                  containerClassName={classes.formInput}
                />
              </div>
              <div className={classes.formBlock}>
                <Title
                  size="xsmall"
                  color="secondary"
                  className={classes.formTitle}
                >
                  Field Type
                </Title>
                <Select
                  className={classes.formSelect}
                  variant="secondary"
                  items={PROCESSOR_FIELD_OPTIONS}
                  getItemLabel={item => capitalize(item as string)}
                  onChange={item => setFieldType(item)}
                  selectedItem={fieldType}
                  stretch
                />
              </div>
            </div>
            <div className={classes.formActions}>
              <Button variant="secondary" lined onClick={onCancel}>
                Cancel
              </Button>
              <Button variant="primary" onClick={onAdd}>
                Add
              </Button>
            </div>
          </div>
        )}
      >
        {props => {
          popoverOnClickRef.current = props.onClick
          return (
            <Button variant="secondary" className={classes.button} {...props}>
              <Plus /> Add Processor Field
            </Button>
          )
        }}
      </Popover>
    </div>
  )
}

export default AddProcessorField
